import React from 'react';
import "./ManagementList.css"
import {NavLink} from "react-router-dom";

const ManagementList = ({users, title}) => {
    return (
        <div className={"users"}>
            <p>
                {title} management
            </p>
            <ul>
                {users.map((user, index) =>
                    <li key={index}>
                        <NavLink
                            to={`/${user.name.toLowerCase()}`}
                            className={({ isActive }) => (isActive ? "active-link" : "link")}
                        >
                            {({ isActive }) => (
                                <>
                                    <h6>{user.name}</h6>
                                    <img
                                        src={isActive ? user.active : user.icon}
                                        alt={`${user.name}_panel_settings`}
                                    />
                                </>
                            )}
                        </NavLink>
                    </li>
                )}
            </ul>
        </div>

    );
};

export default ManagementList;